import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PermissionFeaturesResponse } from "../types/permission-features-response";

@Injectable({ providedIn: "root" })
export class UsersFeatureService {
  constructor(private httpClient: HttpClient) {}

  getPermissionTypeFeatures() {
    return this.httpClient.get<PermissionFeaturesResponse>(
      "/servlets/accounts/permissions/?display=features"
    );
  }
}
